module.exports = __webpack_public_path__ + "static/media/2en.01bf20f0.jpg";